import React from 'react';
import DashboardComponent, { DashboardButton } from '../../components/DashboardComponent';
import AppBarContext from '../../contexts/AppBarContext';
import useLoadContext from '../../hooks/useLoadContext';
//import EmployeeInfoContext from '../../contexts/EmployeeInfoContext';

export default function AccountDashboard(props) {
  props.toast?.dismiss();

  //const [employeeInfo] = useContext(EmployeeInfoContext);

  useLoadContext(AppBarContext, { title: 'My Account' });

  const buttons: DashboardButton[] = [
    {
      onClick: () => {
        props.history.push('/ChangePassword');
      },
      title: 'Change Password',
      visible: true,
    },
  ];

  return <DashboardComponent buttons={buttons} toast={props.toast} />;
}
